<script lang="ts">
  import type {Comment, Poem} from '../types'
  import api from '../api/api'
  import {replaceValues, t} from '../i18n'
  import NewComment from './NewComment.svelte'
  import PaginatedCollectionLoader from '../shared/PaginatedCollectionLoader.svelte'
  import {formatDateTime} from '../utils/format'

  export let comment: Comment
  export let poem: Poem

  let answers: Comment[] = []
  let showNew = false

  const voteUp = async (e: Event) => {
    e.preventDefault()
    await api.put(`/poems/${poem.id}/comments/${comment.id}/up`)
    comment.votes_up += 1
    comment.has_voted = true
  }

  const voteDown = async (e: Event) => {
    e.preventDefault()
    await api.put(`/poems/${poem.id}/comments/${comment.id}/down`)
    comment.votes_down += 1
    comment.has_voted = true
  }

  const writeReplyTo = (e: Event) => {
    e.preventDefault()
    showNew = true
  }

  const onNewAnswer = (answer: Comment) => {
    answers = [answer, ...answers]
    poem.comments_count += 1
    showNew = false
  }
</script>

<div class="comment__item">
  <div class="comment__user_pic">
    <img src={comment.user_image}/>
  </div>
  <div class="comment__content">
    <div class="comment__heading">
      <a class="comment__name" href={`/authors/${comment.user_handle}`}>
        {comment.user_full_name}
        <time class="comment__date">- {formatDateTime(comment.created_at)}</time>
      </a>
    </div>

    <div class="comment__rate">
      {#if !comment.has_voted}
        <i class="icon-p-plus-circle" onclick={voteUp}/>
        <i class="icon-p-minus-circle" onclick={voteDown}/>
      {/if}
      <span class="votes up">{comment.votes_up}</span>
      <span class="votes down">{comment.votes_down}</span>
    </div>

    <div class="comment__text">
      <p>{comment.content}</p>
    </div>

    <span class="comment__reply" onclick={writeReplyTo}>
      {t.poem.comments.reply}
    </span>

  </div>

  {#if showNew}
    <div class="comment__replies">
      <NewComment {poem} onAdded={onNewAnswer}/>
    </div>
  {/if}

  <div class="comment__replies">
    {#each answers as answer}
      <div class="comment__item comment__item--replied">
        <svelte:self {poem} comment={answer}/>
      </div>
    {/each}

    <PaginatedCollectionLoader bind:items={answers} url={`/poems/${poem.id}/comments?reply_to=${comment.id}`} per={10}
                               let:loadNext let:remaining>
      <span class="show-more-replies" onclick={() => loadNext()}>
        {replaceValues(t.poem.comments.view_more_replies, {n: remaining})}
        <i class="icon-p-drop-arrow"/>
      </span>
    </PaginatedCollectionLoader>
  </div>
</div>
